import { AngleUnit } from '@fulcrum/lib';
import { SHARED } from './conversion-constants';
import { AngleMeasurement } from '@trimble/types';
import { BaseConverterProps } from './base-converter-props.types';
import { UnreachableCaseError } from 'ts-essentials';

export const mapToDegrees = ({
  value,
  baseUnit,
}: BaseConverterProps<AngleMeasurement, AngleUnit>): number | null => {
  if (typeof value === 'object') {
    return mapDegreeMinSecToDegrees(
      value.isPositive,
      value.degrees,
      value.minutes,
      value.seconds
    );
  } else {
    switch (baseUnit) {
      case 'deg':
        return value;
      case 'rad':
        return value * SHARED.ANGLE.radiansToDegrees;
      case 'deg-min-sec':
        throw new Error(
          "For 'deg-min-sec' unit, please provide an object with degrees, minutes, and seconds properties."
        );
      default:
        throw new UnreachableCaseError(baseUnit);
    }
  }
};

export const mapDegreeMinSecToDegrees = (
  isPositive: boolean,
  deg: number,
  min: number,
  sec: number
): number => {
  return (
    (isPositive ? 1 : -1) *
    (deg +
      min * SHARED.ANGLE.minutesToDegrees +
      sec * SHARED.ANGLE.secondsToDegrees)
  );
};
